
interface CenteredProps {
    children: React.ReactNode;
}

function Centered({ children }: Readonly<CenteredProps>) {

    return (
        <table style={{ width: '100%' }}>
            <thead className="visually-hidden"><tr><th></th></tr></thead>
            <tbody>
                <tr>
                    <td className='hc-blank-for-menu'>
                    </td>
                    <td>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}
                        >
                            {children}
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>



    )
}

export default Centered;